import { Application } from "stimulus"
import LandingNavController from "../controllers/landing_nav_controller"
import ScrollRevealController from "../controllers/scroll_reveal_controller"
import ScrollProgressController from "../controllers/scroll_progress_controller"
import "./client.scss"

// The public page needs navigation, but no authenticated channel subscriptions.
const application = Application.start()
application.register("landing-nav", LandingNavController)
application.register("scroll-reveal", ScrollRevealController)
application.register("scroll-progress", ScrollProgressController)
